import React from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
  layout?: React.ComponentType;
  roles?: Array<'ADMIN' | 'USER' | 'CLIENT'>;
}
const BlankLayout: React.FC = ({ children }) => <>{children}</>;

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  roles,
  layout: Layout = BlankLayout,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (!user && isPrivate) {
          return (
            <Redirect to={{
              pathname: '/',
              state: { from: location },
            }}
            />
          );
        }

        if (
          (user && !isPrivate)
          || (user && isPrivate && roles && roles?.indexOf(user?.role) <= -1)
        ) {
          return (
            <Redirect to={{
              pathname: '/dashboard',
              state: { from: location },
            }}
            />
          );
        }

        return (
          <Layout>
            <Component />
          </Layout>
        );
      }}
    />
  );
};

export default Route;
